<template>
  <div class="dropdown">
    <button
      class="btn btn-secondary dropdown-toggle"
      type="button"
      id="dropdownMenuButton"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      @click="toggleDD"
    >
      {{ printSelectedOption(selected) }}
    </button>
    <div
      :class="['dropdown-menu', { 'show': isDropDownOpened }]"
      aria-labelledby="dropdownMenuButton"
    >
      <a
        v-for="option in this.options"
        :key="option[identifier]"
        :class="['dropdown-item', {'selected': (!option.disabled && option[identifier]===selected)}, {'disabled': option.disabled}]"
        :href="option[linkKey]"
      >
        {{ option[label] }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["options", "selected", "label", "identifier", "linkKey"],
  data() {
    return {
      isDropDownOpened: false,
    };
  },
  methods: {
    printSelectedOption(selected) {
      let selectedOpt = this.options.find(
        (o) => o[this.identifier] == selected
      );
      if(selectedOpt) {
        return selectedOpt[this.label];
      } else {
        return this.options[0][this.label];
      }
    },
    toggleDD() {
      this.isDropDownOpened = !this.isDropDownOpened;
    },
  },
  mounted() {
    //close dropdown menu on 
    window.onclick = function() {
      if (!event.target.matches('#dropdownMenuButton')) {
       let dropdownContent = document.getElementsByClassName("dropdown-menu");
       var i;
       for (i = 0; i < dropdownContent.length; i++) {
         var openDropdown = dropdownContent[i];
         if (openDropdown.classList.contains('show')) {
         openDropdown.classList.remove('show');
      }
    }
    
  }
    }

  }
};
</script>